<div class="chart-container">
    <canvas #chartCanvas class="graph" [id]="canvasId"></canvas>
    <div [id]="elementId + '-tooltip'" class="tooltip" style="position: absolute; display: none; pointer-events: none;">
        <span [id]="elementId + '-tooltip-content'"></span>
    </div>    
</div>

